module.exports = "https://cdn.dashboard.gifty.nl/2684/images/blueprint-bg.svg?8d3485b350f4f35dc835dd490110a63a";